import { formatMessage } from '@99designs/common/i18n';
import loadImage from 'common/utils/loadImage';
import { StepState } from 'projects/util/step';
import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const images = {
    [1]: require('images/projects/create/Step1.svg'),
    [2]: require('images/projects/create/Step2.svg'),
    [3]: require('images/projects/create/Step3.svg'),
} as { [key: number]: string };

export default class Artwork extends React.Component<{ step: StepState }> {
    static hasDonePreload = false;

    componentDidMount() {
        if (!Artwork.hasDonePreload) {
            Object.keys(images).map(key => loadImage(images[parseInt(key)]));
            Artwork.hasDonePreload = true;
        }
    }

    render() {
        const { step } = this.props;
        let image = <div className="artwork" data-step={step.number} />;

        if (images[step.number]) {
            image = (
                <div className="artwork" data-step={step.number}>
                    <img
                        className="artwork__image"
                        data-step={step.number}
                        src={images[step.number]}
                    />
                    <div className="artwork__attribution">
                        <span className="attribution">
                            {formatMessage(__('by {designer}'), { designer: 'Molecula' })}
                        </span>
                    </div>
                </div>
            );
        }

        return (
            <TransitionGroup>
                <CSSTransition key={step.number} timeout={1000} classNames="fade">
                    {image}
                </CSSTransition>
            </TransitionGroup>
        );
    }
}
